import React, { useEffect, useState, useContext } from "react"
import Flatpickr from "react-flatpickr"

import {
  Col,
  Row,
  Card,
  CardBody,
  Container,
  Label,
  Input,
  InputGroup,
  Form,
  FormFeedback,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Button,
  Spinner,
  CardFooter,
} from "reactstrap"

import Select from "react-select"
import CreatableSelect from "react-select/creatable"

import { Editor } from "@tinymce/tinymce-react"

import classnames from "classnames"

import { checkScope } from "helpers/utility_helper"

// Formik Validation
import * as Yup from "yup"
import { useFormik, FieldArray, FormikProvider } from "formik"

//import components
import Breadcrumbs from "../../../components/Common/Breadcrumb2"
import { withTranslation } from "react-i18next"
import "../../../components/Common/ts-css.css"
import { Link, useNavigate, useParams } from "react-router-dom"
import _ from "lodash"
import fn_helper from "helpers/fn_helper"
import ModalContext from "../../../contexts/ModalContext"
import UploadFileAPI from "components/UploadFileAPI"
import InputLang from "components/Input/InputLang"
import moment from "moment"
import MyEditor from "components/MyEditor"
import UploadFileS3 from "components/UploadFileS3"
import InputAttachment from "components/Input/attachment/InputAttachment"
import PopupAttachment from "components/Input/attachment/PopupAttachment"
import UploadDesc from "components/UploadDesc"
import { ReactSortable } from "react-sortablejs"
import Sortable from "sortablejs"
import Spinners from "components/Common/Spinner"

// Services
import {
  GetContentCateById,
  CreateContentCate,
  UpdateContentCate,
} from "./services/Services"

import InputText from "components/Input/InputText"
import Error401 from "components/Error401"

const STATUS_OPTION = fn_helper.OPTIONS.STATUS_NO_DELETE

const _routeLink = `esg-in-action/highlight`
const _pageName = `Net Zero Highlight`
const _routePermission = `esg-in-action:highlight`

const ESGHighlightDetailTemplate = ({
  pageView = "create",
  componentKey = "",
}) => {
  // POPUP
  const { mAlert } = useContext(ModalContext)

  // OTHER STATE
  const qParams = useParams()
  const qLang = _.upperCase(qParams?.lang) ?? "TH"
  const qMainId = qParams.id
  const navigate = useNavigate()

  const [waitSendData, setWaitSendData] = useState(false)
  const [contentLoading, setContentLoading] = useState(false)
  const [list, setList] = useState([])

  // ========== Form Validation ========== //
  const validationSchema = Yup.object({
    // contentName: Yup.string().max(255).required("Please Enter Name"),
    contentDetail: Yup.string().required("Please Enter Detail"),
    thumbnail: Yup.object()
      .test(
        "is-not-empty-object",
        "Please Upload Image",
        value => value && Object.keys(value).length > 0
      )
      .required("Please Upload Image"),

    contentUpdateDate: Yup.string()
      .max(100)
      .required("Please Select Written at"),
    contentStatus: Yup.string().max(100).required("Please Enter Display"),
  })

  // LOCAL STATE FORM
  const [updatedValidationSchema, setUpdatedValidationSchema] =
    useState(validationSchema)

  const initialValues = {
    contentId: "",

    thumbnail: {},
    bg: {},
    // Content
    contentName: "",
    contentDetail: "",
    contentLinkout: "",
    contentUpdateDate: moment().format("YYYY-MM-DD"),
    contentStatus: "active",
  }

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: initialValues,
    validationSchema: updatedValidationSchema,
    onSubmit: values => {
      console.log(`🚀 ~ ${_pageName} Create ~ values:`, values)
      const payload = {
        id: qMainId,
        contentId: values.contentId ? values.contentId : undefined,
        langId: qLang,
        contentName: values.contentName,
        contentDetail: values.contentDetail,
        contentLinkout: values.contentLinkout,
        contentUpdateDate: values.contentUpdateDate,
        contentStatus: values.contentStatus,

        attachmentData: {},

        contentAttachmentData: {},
      }
      if (values.thumbnail) {
        payload.contentAttachmentData["thumbnail"] = values.thumbnail
      }
      if (values.bg) {
        payload.contentAttachmentData["bg"] = values.bg
      }

      console.log("🚀 ~ onSave ~ payload:", payload)

      setWaitSendData(true)
      if (pageView === "update") {
        API.fetchUpdateContentCate(payload)
      } else {
        API.fetchCreateContentCate(payload)
      }
    },
  })

  const preFilInput = (resData = {}) => {
    console.log("🚀 ~ preFilInput ~ resData:", resData)
    // resetForm(validation.values, initialValues)

    // ถ้าไม่หน่วงมันจะแย่งกันทำ
    validation.setFieldValue("contentId", resData?.contentId ?? "")
    validation.setFieldValue("contentName", resData?.contentName ?? "")
    validation.setFieldValue("contentDetail", resData?.contentDetail ?? "")
    validation.setFieldValue("contentLinkout", resData?.contentLinkout ?? "")

    validation.setFieldValue(
      "thumbnail",
      resData?.contentAttachmentList?.find(
        obj => obj.attachmentField == "thumbnail"
      ) ?? ""
    )

    validation.setFieldValue(
      "contentUpdateDate",
      resData?.contentUpdateDate ?? moment().format("YYYY-MM-DD")
    )
    validation.setFieldValue(
      "contentStatus",
      resData?.contentStatus ?? "active"
    )
  }

  const preFilInputPage = (resData = {}) => {
    console.log("🚀 ~ preFilInputPage ~ resData:", resData)
    validation.setFieldValue("contentName", resData?.contentPageName ?? "")
  }

  const API = {
    fetchGetContentCateById: async payload => {
      try {
        const response = await GetContentCateById({
          id: payload.id,
          lang: qLang,
        })
        const resData = response.data
        if (resData.status == 200) {
          preFilInput(resData.data)
        }
      } catch (err) {
        console.log("err ", err)
        mAlert.info({
          title: "Alert",
          subTitle: "Something went wrong 001",
          content: "",
          onClose: () => {
            //  alert("onClose")
          },
        })
      } finally {
        setContentLoading(false)
      }
    },
    fetchCreateContentCate: async (payload, pageDetailRoute) => {
      try {
        // const responseP = await SavePageDetail(componentKey, { data: pageDetailRoute, lang: qLang })
        const response = await CreateContentCate({ data: payload, lang: qLang })
        const resData = response.data
        if (resData.status == 201) {
          mAlert.info({
            title: "Alert",
            subTitle: "Created Data Success",
            content: "",
            onClose: () => {
              navigate(`/${_routeLink}/${qLang}/edit/${resData.data.mainId}`)
            },
          })
        }
      } catch (e) {
        console.log(e)
        mAlert.info({
          title: "Alert",
          subTitle: "Something went wrong",
          content: "",
          onClose: () => {
            //  alert("onClose")
          },
        })
      } finally {
        setWaitSendData(false)
      }
    },
    fetchUpdateContentCate: async (payload, pageDetailRoute) => {
      try {
        // const responseP = await UpdatePageDetail(componentKey, { data: pageDetailRoute, lang: qLang })
        const response = await UpdateContentCate({
          data: payload,
          id: payload.id,
          lang: qLang,
        })
        const resData = response.data
        if (resData.status == 202) {
          mAlert.info({
            title: "Alert",
            subTitle: "Update Data Success",
            content: "",
            onClose: () => {
              navigate(`/${_routeLink}/${qLang}/edit/${qMainId}`)
            },
          })
        }
      } catch (err) {
        console.log("err ", err)
        mAlert.info({
          title: "Alert",
          subTitle: "Something went wrong",
          content: "",
          onClose: () => {
            //  alert("onClose")
          },
        })
      } finally {
        setWaitSendData(false)
      }
    },
  }

  // กรณี Edit
  useEffect(() => {
    if (["update", "view"].includes(pageView)) {
      const payload = { id: qMainId }
      setContentLoading(true)
      API.fetchGetContentCateById(payload)
    }
  }, [qLang])

  const PAGE_VIEW = _.capitalize(_.first(pageView) + pageView.slice(1))
  document.title =
    `${_pageName} | ${PAGE_VIEW} | ` + process.env.REACT_APP_CMS_TITLE

  const itemStyle = {
    padding: "10px",
    border: "1px solid black",
    margin: "5px",
    borderRadius: "8px",
    background: "#f9f9f9",
    transition: "transform 0.2s ease, background-color 0.3s ease",
  }

  const mapValues = (list = []) =>
    list.map(item => {
      const newObj = {
        attachmentId: item.attachmentId,
        sequence: item.sequence,
      }
      return newObj
    })

  if (
    !checkScope(`${_routePermission}:create`) ||
    !checkScope(`${_routePermission}:update`) ||
    !checkScope(`${_routePermission}:view`)
  ) {
    return <Error401 />
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs
            title={`${PAGE_VIEW} ${_pageName}`}
            breadcrumbItems={[
              { title: _pageName, link: "" },
              { title: PAGE_VIEW },
            ]}
          />

          {/* Render Form */}
          {contentLoading ? (
            <Spinners setLoading={setContentLoading} />
          ) : (
            <Row>
              <Col className="col-12">
                <FormikProvider value={validation}>
                  <Form
                    className="form-horizontal"
                    onSubmit={e => {
                      e.preventDefault()
                      validation.handleSubmit()
                      return false
                    }}
                  >
                    <Row>
                      <Col className="col-8">
                        <Card>
                          <h5 className="card-header bg-transparent border-bottom text-uppercase">
                            <i className="bx bx-cube-alt"></i> Information Box
                          </h5>
                          <CardBody>
                            <Col className="col-12 mb-3">
                              <div className="col-md-12">
                                <PopupAttachment
                                  typeDetail="single"
                                  typeUpload="ImageMap"
                                  upload="Image"
                                  prefixName="page-thumbnail"
                                  label="Image"
                                  required={true}
                                  description="description"
                                  widthSize={1200}
                                  heightSize={720}
                                  value={validation.values.thumbnail}
                                  onChange={(value = {}, index) => {
                                    console.log("🚀 onChange ~ value:", value)
                                    console.log("🚀 onChange ~ index:", index)
                                    validation.setFieldValue("thumbnail", value)
                                  }}
                                  onRemove={index => {
                                    console.log("🚀 onChange ~ index:", index)
                                    validation.setFieldValue("thumbnail", {})
                                  }}
                                />
                                {validation.touched.thumbnail &&
                                  validation.errors.thumbnail && (
                                    <div
                                      type="invalid"
                                      className="invalid-feedback d-block"
                                    >
                                      {validation.errors.thumbnail}
                                    </div>
                                  )}
                              </div>
                              <hr />
                            </Col>
                            <Col className="col-12 mb-3">
                              <label
                                htmlFor="contentDetail"
                                className="col-md-12 col-form-label"
                              >
                                Detail
                                <span className="t-require">*</span>
                              </label>
                              <div className="col-md-12">
                                <MyEditor
                                  id="contentDetail"
                                  placeholder=""
                                  name="contentDetail"
                                  onChange={(e, editor) => {
                                    const data = editor.getData()
                                    validation.setFieldValue(
                                      "contentDetail",
                                      data
                                    )
                                    console.log({ e, editor, data })
                                  }}
                                  onBlur={validation.handleBlur}
                                  value={validation.values.contentDetail}
                                  invalid={
                                    validation.touched.contentDetail &&
                                      validation.errors.contentDetail
                                      ? true
                                      : false
                                  }
                                  disabled={pageView === "view"}
                                />
                                {validation.touched.contentDetail &&
                                  validation.errors.contentDetail && (
                                    <FormFeedback type="invalid">
                                      {validation.errors.contentDetail}
                                    </FormFeedback>
                                  )}
                              </div>
                              <hr />
                            </Col>

                            <Row>
                              <Col className="col-12 mb-3">
                                <label
                                  htmlFor="contentLinkout"
                                  className="col-md-12 col-form-label"
                                >
                                  Link URL
                                  {/* <span className="t-require">*</span> */}
                                </label>
                                <div className="col-md-12">
                                  <InputText
                                    id="contentLinkout"
                                    className="form-control"
                                    type="text"
                                    placeholder=""
                                    name="contentLinkout"
                                    onChange={e => {
                                      validation.setFieldValue(
                                        "contentLinkout",
                                        e.target.value
                                      )
                                    }}
                                    onBlur={validation.handleBlur}
                                    value={validation.values.contentLinkout}
                                    invalid={
                                      validation.touched.contentLinkout &&
                                        validation.errors.contentLinkout
                                        ? true
                                        : false
                                    }
                                    disabled={pageView === "view"}
                                    errorText={validation.errors.contentLinkout}
                                    maxLength={9999}
                                  />
                                </div>
                                <hr />
                              </Col>
                            </Row>
                          </CardBody>
                        </Card>
                      </Col>
                      <Col className="col-4">
                        <Card
                          outline
                          color="primary"
                          className="border sticky-element"
                        >
                          <h5 className="card-header bg-transparent border-bottom text-primary text-uppercase">
                            <i className="bx bx-check"></i> Tools Box
                          </h5>
                          <CardBody>
                            <Row>
                              <Col className="col-12 mb-3">
                                <label
                                  htmlFor="category_name"
                                  className="col-md-12 col-form-label"
                                >
                                  Switch Language
                                  <span className="t-require">*</span>
                                </label>
                                <div className="col-md-12">
                                  <InputLang
                                    widthfull
                                    pageView={pageView}
                                    forceRoute={false}
                                  />
                                </div>
                              </Col>
                              <Col className="col-12 mb-3">
                                <label
                                  htmlFor="category_name"
                                  className="col-md-12 col-form-label"
                                >
                                  Written at
                                  <span className="t-require">*</span>
                                </label>
                                <div className="col-md-12">
                                  <InputGroup>
                                    <Flatpickr
                                      className="form-control d-block"
                                      options={{
                                        dateFormat: "d/m/Y", // กำหนดรูปแบบวันที่ เช่น 15/08/1997
                                      }}
                                      value={
                                        validation.values.contentUpdateDate
                                          ? moment(
                                            validation.values
                                              .contentUpdateDate,
                                            "YYYY-MM-DD"
                                          ).toDate()
                                          : null
                                      }
                                      disabled={true}
                                    />
                                    <div className="input-group-append">
                                      <button
                                        type="button"
                                        className="btn btn-outline-secondary docs-datepicker-trigger"
                                        disabled
                                      >
                                        <i
                                          className="fa fa-calendar"
                                          aria-hidden="true"
                                        />
                                      </button>
                                    </div>
                                  </InputGroup>
                                  {validation.touched.contentUpdateDate &&
                                    validation.errors.contentUpdateDate && (
                                      <div
                                        type="invalid"
                                        className="invalid-feedback d-block"
                                      >
                                        {validation.errors.contentUpdateDate}
                                      </div>
                                    )}
                                </div>
                              </Col>
                              <Col className="col-12 mb-3">
                                <label
                                  htmlFor="category_name"
                                  className="col-md-12 col-form-label"
                                >
                                  Display
                                  <span className="t-require">*</span>
                                </label>
                                <div className="col-md-12">
                                  <Select
                                    placeholder="Select Status"
                                    value={fn_helper.FNFORM.getObjectValue(
                                      STATUS_OPTION,
                                      `${validation.values.contentStatus}`
                                    )}
                                    onChange={value =>
                                      validation.setFieldValue(
                                        "contentStatus",
                                        value.id
                                      )
                                    }
                                    getOptionValue={option => option.id}
                                    getOptionLabel={option => option.name}
                                    options={STATUS_OPTION}
                                    className={`select2-selection ${validation.touched.contentStatus &&
                                      validation.errors.contentStatus
                                      ? "input-err"
                                      : ""
                                      }`}
                                    isDisabled={pageView === "view"}
                                  />
                                  {validation.touched.contentStatus &&
                                    validation.errors.contentStatus && (
                                      <div
                                        type="invalid"
                                        className="invalid-feedback d-block"
                                      >
                                        {validation.errors.contentStatus}
                                      </div>
                                    )}
                                </div>
                              </Col>
                            </Row>
                          </CardBody>
                          <CardFooter>
                            <Row>
                              <Col className="text-start">
                                <Button
                                  color="danger"
                                  className="btn btn-danger"
                                  onClick={() =>
                                    navigate(`/${_routeLink}/${qLang}`)
                                  }
                                >
                                  Back
                                </Button>
                              </Col>
                              <Col className="text-end">
                                {pageView !== "view" && (
                                  <Button
                                    type="submit"
                                    className="btn btn-success"
                                  >
                                    Save{" "}
                                    {waitSendData ? (
                                      <Spinner size="sm" color="light" />
                                    ) : null}
                                  </Button>
                                )}
                              </Col>
                            </Row>
                          </CardFooter>
                        </Card>
                      </Col>
                    </Row>
                  </Form>
                </FormikProvider>
              </Col>
            </Row>
          )}
        </Container>
      </div>
    </React.Fragment>
  )
}

// QuestionaireCategory.propTypes = {
//     t: PropTypes.any,
// };

export default withTranslation()(ESGHighlightDetailTemplate)
